import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import {
    saveUserLastPath,
    saveUserLoginSlug,
    persistLastTenantSlug,
} from '../utils/sessionNavigation.js';

/** Guarda la última ruta y slug de login por usuario autenticado. */
export default function SessionNavigationTracker() {
    const { user } = useAuth();
    const location = useLocation();

    useEffect(() => {
        if (!user) return;
        const path = `${location.pathname}${location.search}`;
        saveUserLastPath(user, path);
        const slug = user.tenantSlug ?? user.tenant_slug;
        if (slug) {
            persistLastTenantSlug(slug);
            saveUserLoginSlug(user, slug);
        }
    }, [user, location.pathname, location.search]);

    return null;
}
